
export default function GallerySection() {
  const galleryItems = [
    { image: '/images/artists/agatha/w1.png', likes: '1,240', video: false },
    { image: '/images/artists/paz/w1.png', likes: '856', video: true },
    { image: '/images/artists/naz/w1.png', likes: '2,100', video: false },
    { image: '/images/artists/fanny/w1.png', likes: '943', video: false },
    { image: '/images/gallery-001.jpg', likes: '1,532', video: true },
    { image: '/images/gallery-002.jpg', likes: '3,400', video: false },
    { image: '/images/gallery-003.jpg', likes: '890', video: false },
    { image: '/images/gallery-004.jpg', likes: '1,120', video: false },
  ];

  return (
    <section id="galeria" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {galleryItems.map((item, index) => (
            <a
              key={index}
              href="https://www.instagram.com/rebel_rabbit_tattoo/"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden rounded-xl bg-gray-100 block"
            >
              <img
                src={item.image}
                alt="Rebel Rabbit Instagram"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <i className="ri-instagram-line text-4xl text-white"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-gray-600 mb-6 max-w-2xl">
            Cada día subimos nuevos trabajos, flashes disponibles y noticias del estudio.
            ¡No te pierdas nada!
          </p>
          <a
            href="https://www.instagram.com/rebel_rabbit_tattoo/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-lg hover:scale-105 transition-all duration-300"
          >
            <i className="ri-instagram-line text-2xl"></i>
            Ir al Instagram Real
          </a>
        </div>
      </div>
    </section>
  );
}
